import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import SignUpModal from './components/SignUpModal';
import ProfileModal from './components/ProfileModal';
import ChatsModal from './components/ChatsModal';
import SettingsModal from './components/SettingsModal';
import ListingsModal from './components/ListingsModal';
import api from './services/api';

const BRAND_LOGO_URL = 'https://i.postimg.cc/44mFB7xb/b82d446d_ea30_4c43_a9b9_caf02c25e896_removalai_preview.png';

const pageContent = {
  'about-us': {
    title: 'About GhanaStay',
    description: 'Learn about GhanaStay and how we help renters and property owners connect across Ghana.',
    sections: [
      {
        heading: 'Who we are',
        body: 'GhanaStay is a modern rental marketplace built to help people find safe, verified, and convenient accommodation across Ghana. We focus on making property discovery simple for renters and effective for property owners.'
      },
      {
        heading: 'What we do',
        body: 'We make it easier to browse listings, connect with owners, compare options, and discover homes that fit different budgets, locations, and lifestyles.'
      },
      {
        heading: 'Our mission',
        body: 'Our mission is to make renting in Ghana more transparent, more trustworthy, and more accessible for everyone.'
      }
    ]
  },
  'help-center': {
    title: 'Help Center',
    description: 'Get support for using GhanaStay, finding properties, and managing your account.',
    sections: [
      {
        heading: 'Finding a property',
        body: 'Use the search bar and property filters to narrow listings by area, price, and property type. Open listing details to review amenities, location, and landlord information.'
      },
      {
        heading: 'Managing your account',
        body: 'After signing in, you can manage your profile, view chats, update account settings, and keep track of your listings from the account menu.'
      },
      {
        heading: 'Getting more help',
        body: 'If you need direct assistance, use the Contact Us at support@ghanastay.app and include clear details about the issue you are facing.'
      }
    ]
  },
  safety: {
    title: 'Safety on GhanaStay',
    description: 'Safety tips and best practices for renters and property owners using GhanaStay.',
    sections: [
      {
        heading: 'Meet carefully',
        body: 'Arrange property viewings in safe locations and at appropriate times. If possible, attend with someone you trust.'
      },
      {
        heading: 'Verify details',
        body: 'Confirm listing details, rent terms, property condition, and ownership information before making any payment or commitment.'
      },
      {
        heading: 'Report suspicious activity',
        body: 'If a listing, message, or user feels suspicious, report it immediately so the GhanaStay team can review it.'
      }
    ]
  },
  'contact-us': {
    title: 'Contact Us',
    description: 'Reach out to GhanaStay for support, partnership opportunities, or account assistance.',
    sections: [
      {
        heading: 'Support',
        body: 'For account, listing, or platform support, contact the GhanaStay team at support@ghanastay.app and include the relevant listing or account details where possible.'
      },
      {
        heading: 'Business inquiries',
        body: 'If you want to partner with GhanaStay or discuss growth opportunities, reach out to us at info@ghanastay.app'
      },
      {
        heading: 'Response expectations',
        body: 'We aim to review inquiries promptly and provide helpful guidance based on the issue or request submitted.'
      }
    ]
  },
  'terms-of-service': {
    title: 'Terms of Service',
    description: 'Review the terms that govern use of the GhanaStay platform.',
    sections: [
      {
        heading: 'Using the platform',
        body: 'By using GhanaStay, users agree to interact with the platform responsibly, provide accurate information, and avoid misleading or harmful conduct.'
      },
      {
        heading: 'Listings and user content',
        body: 'Property owners and users are responsible for the accuracy of listings, messages, profile details, and any other information posted through the platform.'
      },
      {
        heading: 'Platform rights',
        body: 'GhanaStay may review, update, or remove content and features where necessary to maintain safety, quality, compliance, and platform integrity.'
      }
    ]
  },
  'privacy-policy': {
  title: 'Privacy Policy',
  description: 'Welcome to GhanaStay. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our platform.',

  sections: [
    {
      heading: 'Introduction',
      body: 'GhanaStay operates as an online platform that helps landlords, property agents, and visitors connect for accommodation inquiries in Ghana. This Privacy Policy explains what information we collect, how we use it, and how we protect your data when you use our website.'
    },

    {
      heading: 'Information we collect',
      body: 'When you use GhanaStay, we collect certain personal information including your name, email address, and profile details when you create an account or sign in using Google. We also collect information you provide when contacting landlords or agents through the platform. In addition, basic technical information such as browser type, device information, and IP address may be collected automatically to help us improve the performance and security of the website.'
    },

    {
      heading: 'Google Sign-In and authentication',
      body: 'If you sign in using Google, GhanaStay receives basic profile information from your Google account such as your name, email address, and profile picture. This information is used only to create and manage your account on GhanaStay. We do not access your Google password and we do not access any other private data from your Google account.'
    },

    {
      heading: 'How we use your information',
      body: 'The information we collect is used to create and manage your user account, allow communication between property seekers and property owners or agents, improve our platform and user experience, maintain the security of the website, and provide customer support when necessary.'
    },

    {
      heading: 'Sharing of information',
      body: 'GhanaStay does not sell or rent personal information to third parties. Information may only be shared when necessary to operate the platform, comply with legal obligations, protect the rights or safety of users, or when required by law.'
    },

    {
      heading: 'Privacy and data protection',
      body: 'We take reasonable technical and organizational measures to protect personal information from unauthorized access, loss, misuse, or alteration. While we work to protect user data, no internet-based system can guarantee absolute security.'
    },

    {
      heading: 'Third-party services',
      body: 'Our platform use trusted third-party services such as Google authentication to provide login functionality. These services may process certain information in accordance with their own privacy policies.'
    },

    {
      heading: 'User rights',
      body: 'Users may request to update or delete their account information at any time. If you wish to modify or remove your personal data from our system, you may contact us using the details provided below.'
    },

    {
      heading: 'Changes to this policy',
      body: 'We may update this Privacy Policy from time to time to reflect improvements to our services or legal requirements. When changes are made, the updated policy will be posted on this page.'
    },

    {
      heading: 'Contact us',
      body: 'If you have any questions about this Privacy Policy or how your information is handled, you may contact GhanaStay at: support@ghanastay.app'
    }
   ]
 },
  'cookie-policy': {
    title: 'Cookie Policy',
    description: 'Learn how GhanaStay uses cookies and similar technologies.',
    sections: [
      {
        heading: 'Why we use cookies',
        body: 'Cookies help maintain sessions, remember preferences, support authentication flows, and improve the overall user experience.'
      },
      {
        heading: 'Analytics and functionality',
        body: 'We may use cookies or similar technologies to understand platform usage, improve performance, and support key features.'
      },
      {
        heading: 'Managing cookies',
        body: 'Users can manage cookies through browser settings, though disabling some cookies may affect certain features or sign-in behavior.'
      }
    ]
  },
  sitemap: {
    title: 'Sitemap',
    description: 'Browse important GhanaStay pages and discover key property search entry points.',
    sections: [
      {
        heading: 'Explore GhanaStay',
        body: 'Use the links below to access core pages, legal documents, support resources, and discover rental categories across the platform.'
      }
    ],
    links: [
      { label: 'Home', href: '/' },
      { label: 'About Us', href: '/about-us' },
      { label: 'Help Center', href: '/help-center' },
      { label: 'Safety', href: '/safety' },
      { label: 'Contact Us', href: '/contact-us' },
      { label: 'Terms of Service', href: '/terms-of-service' },
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Cookie Policy', href: '/cookie-policy' }
    ]
  }
};

function StaticPage({ pageKey }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const content = pageContent[pageKey] || pageContent['about-us'];
  const showAuthModal = location.pathname.endsWith('/signin');
  const showSignUpModal = location.pathname.endsWith('/signup');
  const showProfileModal = location.pathname.endsWith('/profile');
  const showListingsModal = location.pathname.endsWith('/listings');
  const showChatsModal = location.pathname.endsWith('/chats');
  const showSettingsModal = location.pathname.endsWith('/settings');

  useEffect(() => {
    document.title = `${content.title} | GhanaStay`;
  }, [content.title]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const userData = await api.getUser();
        if (userData) {
          setUser(userData);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setUser(null);
      }
    };

    checkAuth();
  }, [location.pathname]);

  const handleSignOut = async () => {
    try {
      await api.logout();
      setUser(null);
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const handleSaveProfile = async (profileData) => {
    const updatedUser = await api.updateProfile(profileData);
    setUser(updatedUser);
    return updatedUser;
  };

  const handleListProperty = () => {
    if (user) {
      navigate(`/${pageKey}/listings`);
    } else {
      navigate(`/${pageKey}/signin`);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="fixed top-0 left-0 right-0 h-24 bg-gradient-to-br from-blue-50 via-white to-blue-50 z-40"></div>
      <Navbar
        user={user}
        onSignIn={() => navigate(`/${pageKey}/signin`)}
        onRegister={() => navigate(`/${pageKey}/signup`)}
        onSignOut={handleSignOut}
        onProfileClick={() => navigate(`/${pageKey}/profile`)}
        onListingsClick={() => navigate(`/${pageKey}/listings`)}
        onChatsClick={() => navigate(`/${pageKey}/chats`)}
        onSettingsClick={() => navigate(`/${pageKey}/settings`)}
        onSearch={() => navigate('/')}
        onListProperty={handleListProperty}
        searching={false}
      />

      <AuthModal isOpen={showAuthModal} onClose={() => navigate(`/${pageKey}`)} onSwitchToSignUp={() => navigate(`/${pageKey}/signup`)} />
      <SignUpModal isOpen={showSignUpModal} onClose={() => navigate(`/${pageKey}`)} onSwitchToSignIn={() => navigate(`/${pageKey}/signin`)} />
      <ProfileModal isOpen={showProfileModal} onClose={() => navigate(`/${pageKey}`)} user={user} onSave={handleSaveProfile} />
      <ListingsModal isOpen={showListingsModal} onClose={() => navigate(`/${pageKey}`)} user={user} onListingChange={() => {}} />
      <ChatsModal isOpen={showChatsModal} onClose={() => navigate(`/${pageKey}`)} user={user} initialPropertyId={null} initialReceiverId={null} />
      <SettingsModal isOpen={showSettingsModal} onClose={() => navigate(`/${pageKey}`)} user={user} />

      <div className="max-w-5xl mx-auto px-6 py-10">
        <div className="bg-white rounded-3xl shadow-sm border border-blue-100 overflow-hidden">
          <div className="bg-white px-8 py-10 text-blue-700 border-b border-blue-100">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="max-w-3xl">
                <p className="text-sm uppercase tracking-[0.2em] text-blue-500 mb-3">GhanaStay</p>
                <h1 className="text-4xl font-semibold mb-3 text-blue-700">{content.title}</h1>
                <p className="text-blue-600 text-base leading-7">{content.description}</p>
              </div>
              <div className="flex justify-end md:min-w-[180px]">
                <img
                  src={BRAND_LOGO_URL}
                  alt="GhanaStay"
                  className="h-20 w-36 object-contain object-right"
                />
              </div>
            </div>
          </div>

          <div className="px-8 py-10 space-y-10">
            {content.sections.map((section) => (
              <section key={section.heading} className="border-b border-gray-100 pb-8 last:border-b-0 last:pb-0">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">{section.heading}</h2>
                <p className="text-gray-600 leading-8 text-base">{section.body}</p>
              </section>
            ))}

            {content.links && (
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">Quick links</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {content.links.map((link) => (
                    <button
                      key={link.href}
                      onClick={() => navigate(link.href)}
                      className="text-left rounded-2xl border border-blue-100 bg-blue-50 px-5 py-4 text-blue-700 hover:bg-blue-100 transition-colors"
                    >
                      {link.label}
                    </button>
                  ))}
                </div>
              </section>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <Footer onListYourProperty={handleListProperty} />
      </div>
    </div>
  );
}

export default StaticPage;
